import React from "react";
import { Card, Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { buildQS, parseQS } from "@components/Utils";

export default function DjangoPaginator({ pager }) {
    const navigate = useNavigate();

    if (!pager) {
        return;
    }

    const changePage = (p) => {
        const getParams = { ...parseQS(), page: p };
        navigate({ search: "?" + buildQS(getParams) });
    };

    return (
        <Paginator
            curPage={pager.number}
            numPages={pager.num_pages}
            rangePages={pager.range_pages}
            rangePrev={pager.range_prev}
            rangeNext={pager.range_next}
            disableListCount={pager.disable_list_count}
            changePage={changePage}
        />
    );
}

export function Paginator({ curPage, numPages, changePage, rangePages, rangePrev, rangeNext, disableListCount }) {
    if (!curPage || !numPages || !changePage || numPages < 2) {
        return <></>;
    }

    curPage = parseInt(curPage);

    if (rangePages === undefined) {
        const pageRange = 10;
        rangePrev = Math.max(curPage - pageRange - 1, 1);
        rangeNext = Math.min(curPage + pageRange + 1, numPages);
        rangePages = [];
        for (let i = rangePrev + 1; i < rangeNext; i++) {
            rangePages.push(i);
        }
    }

    return (
        <Card.Footer>
            <Pagination size="sm" className="mb-0">
                <Pagination.Item active={curPage === 1} onClick={() => changePage(1)}>
                    1
                </Pagination.Item>

                {rangePrev > 1 && <Pagination.Prev onClick={() => changePage(rangePrev)} />}

                {rangePages.map((p) => (
                    <Pagination.Item key={`page${p}`} active={curPage === p} onClick={() => changePage(p)}>
                        {p}
                    </Pagination.Item>
                ))}

                {rangeNext < numPages && <Pagination.Next onClick={() => changePage(rangeNext)} />}

                {!disableListCount && (
                    <Pagination.Item active={curPage === numPages} onClick={() => changePage(numPages)}>
                        {numPages}
                    </Pagination.Item>
                )}
            </Pagination>
        </Card.Footer>
    );
}

export function SimplePaginator({ curPage, changePage, prevPage, nextPage }) {
    return (
        curPage && (
            <Card.Footer>
                <Pagination size="sm" className="mb-0">
                    {prevPage && <Pagination.Prev onClick={() => changePage(prevPage)} />}

                    <Pagination.Item active={true}>{curPage}</Pagination.Item>

                    {nextPage && <Pagination.Next onClick={() => changePage(nextPage)} />}
                </Pagination>
            </Card.Footer>
        )
    );
}
